var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classObj},[_c('h3',[_vm._t("subheader")],2),_c('div',{class:`list-content`},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }